import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  { name: "Sarah M.", area: "Glenmore, Kelowna", text: "Our cream carpets looked hopeless after two kids and a dog. They came out looking brand new and dried so fast. Honestly the best carpet cleaning we've had." },
  { name: "David & Lynn T.", area: "West Kelowna", text: "Booked a move-out clean and got our full deposit back. Punctual, professional and the price was exactly what they quoted. Highly recommend." },
  { name: "Marcus R.", area: "Downtown Kelowna", text: "We use them for our office every quarter. Minimal disruption, great communication and the carpets always look sharp for clients." },
  { name: "Priya K.", area: "Lake Country", text: "Had them clean our sectional and dining chairs — stains I thought were permanent are just gone. Friendly team and genuinely honest service." },
];

export default function Testimonials() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 md:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="label-caps mb-4">Reviews</div>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1A2A5E]">
              Loved by homeowners & businesses across the Okanagan.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className={`w-5 h-5 ${i < 4 ? "fill-[#2B4BB8] text-[#2B4BB8]" : "fill-[#2B4BB8]/40 text-[#2B4BB8]/40"}`} />)}</div>
            <span className="font-bold text-[#0F172A]">4.6 · 124 Google reviews</span>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
              className="bg-white border border-[#E2E8F0] rounded-sm p-6 hover:shadow-lg transition-shadow flex flex-col"
            >
              <Quote className="w-8 h-8 text-[#2B4BB8]/30" />
              <p className="mt-3 text-sm text-[#334155] leading-relaxed flex-1">"{r.text}"</p>
              <div className="mt-5 pt-4 border-t border-[#F1F5F9]">
                <div className="font-display font-bold text-[#0F172A]">{r.name}</div>
                <div className="text-xs text-[#475569]">{r.area}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
